/* Folder files (3 Nov 2026): pure helpers for the Files list in My access. */

import type { FolderFile } from '../types'
import type { ExplorerNode } from '../routes/myAccessTree'

export type FileKind = 'doc' | 'sheet' | 'slides' | 'pdf' | 'image' | 'video' | 'other'

export function fileKind(mimeType: string): FileKind {
  if (mimeType === 'application/vnd.google-apps.document' || mimeType.includes('wordprocessingml') || mimeType === 'application/msword' || mimeType === 'text/plain') return 'doc'
  if (mimeType === 'application/vnd.google-apps.spreadsheet' || mimeType.includes('spreadsheetml') || mimeType === 'application/vnd.ms-excel' || mimeType === 'text/csv') return 'sheet'
  if (mimeType === 'application/vnd.google-apps.presentation' || mimeType.includes('presentationml') || mimeType === 'application/vnd.ms-powerpoint') return 'slides'
  if (mimeType === 'application/pdf') return 'pdf'
  if (mimeType.startsWith('image/')) return 'image'
  if (mimeType.startsWith('video/')) return 'video'
  return 'other'
}

/** "Changed 3 Nov 2026 · Jane Doe", in the viewer's time zone; parts Drive did not give are left out. */
export function fileMeta(f: Pick<FolderFile, 'modifiedTime' | 'modifiedBy'>): string {
  const t = f.modifiedTime ? new Date(f.modifiedTime) : null
  const date = t && !isNaN(t.getTime())
    ? t.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })
    : null
  if (date && f.modifiedBy) return `Changed ${date} · ${f.modifiedBy}`
  if (date) return `Changed ${date}`
  return f.modifiedBy ? `Changed by ${f.modifiedBy}` : ''
}

/** Files show only on a folder the person can open: never a drive page, a pass-through level or an unchecked folder. */
export function showsFiles(node: ExplorerNode, enabled: boolean): boolean {
  return enabled && node.kind !== 'drive' && !node.pass && node.folder?.state === 'visible'
}

/** Show more: a file edited between pages moves to the top of Drive's order, so skip ones already listed. */
export function appendUnique(have: FolderFile[], more: FolderFile[]): FolderFile[] {
  const seen = new Set(have.map((f) => f.id))
  return [...have, ...more.filter((f) => !seen.has(f.id))]
}
